import type { PizzaSeriesPoint } from '@/lib/types';

type Props = {
  latestPoint: PizzaSeriesPoint | null;
};

function f(value: number, max = 2) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: max }).format(value);
}

export function StatCards({ latestPoint }: Props) {
  if (!latestPoint) {
    return null;
  }

  const pizzasPerBtc = latestPoint.btcUsd / latestPoint.pizzaUsd;
  const pizzasFor10k = pizzasPerBtc * 10_000;

  return (
    <div className="stats-grid" aria-label="Current chart highlights">
      <article className="stat-card">
        <h3>1 BTC buys</h3>
        <p>{f(pizzasPerBtc, 2)} pizzas</p>
      </article>
      <article className="stat-card">
        <h3>10,000 BTC buys</h3>
        <p>{f(pizzasFor10k, 0)} pizzas</p>
      </article>
      <article className="stat-card">
        <h3>Current pizza model value</h3>
        <p>${f(latestPoint.pizzaUsd, 2)} / pizza</p>
      </article>
    </div>
  );
}
